export class TaskCountFilterRequest  {
  adtCodeList: string[];
  taskTypeCountList: string[];

  public constructor(init?: Partial<TaskCountFilterRequest>) {
    Object.assign(this, init);
  }
}
